import { Money } from 'shared/types/product';
import { FinishData } from 'shared/types/product/Product';
import useI18n from 'helpers/hooks/useI18n';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import { ExtendedVariant } from 'shared/types/product/Variant';

export const useFinishPrice = (variant: ExtendedVariant, quantity: number, finish?: FinishData) => {
  const { currency, locale } = useI18n();

  if (!finish) return undefined;

  const finishPrice: Money = {
    ...variant.finishPrice,
    centAmount: Math.round((variant.finishPrice?.centAmount ?? 0) * (finish?.multiplier ?? 0) * quantity),
  };

  const finishPriceFormatted = variant.finishPrice?.centAmount
    ? CurrencyHelpers.formatForCurrency(finishPrice, locale, currency)
    : undefined;

  return { finishPrice, finishPriceFormatted };
};
